let ajax = null
let avatarUrl = null
const userIcon = document.querySelector('user-icon')
document.addEventListener("DOMContentLoaded", () => {

if (currentCustomer && !userIcon.avatar) {
    ajax = new AjaxRequest({ withCredentials: true })
    avatarUrl = domains.tron_url + '/shopify/user-lookup/' + currentCustomer.email
    ajax.GET(avatarUrl, (response) => {
      console.log('making request for avatarData --> ', response)
      if ( response && response.avatar ) {
        currentCustomer.avatar = response.avatar
        replaceShownUserIcon('true', response.avatar)
        replaceHiddenUserIcon('true', response.avatar)
      }
    })
  }



function replaceUserIcon(loggedIn = 'true', avatar = '') {
  if (currentCustomer && currentCustomer.email) {
    const userDivElement = document.querySelector('.user-drop .drop-header div')
    const previousUserIcon = document.querySelector('user-icon')
    if (previousUserIcon) {
      previousUserIcon.remove()
    }
    const userIconElement = document.createElement('user-icon')
    userIconElement.setAttribute('logged-in', loggedIn)
    userIconElement.setAttribute('avatar', avatar)


    userDivElement.append(userIconElement)
  }
}

function replaceShownUserIcon(loggedIn = 'true', avatar = '') {
 if (currentCustomer && currentCustomer.email) {
    const userShowDivElement = document.querySelector('.user-drop .drop-header div.show-dh')
    const previousUserIcon = userShowDivElement.querySelector('user-icon')
    if (previousUserIcon) {
      previousUserIcon.remove()
    }
    const userIconElement = document.createElement('user-icon')
    userIconElement.setAttribute('logged-in', loggedIn)
    userIconElement.setAttribute('avatar', avatar)


    userShowDivElement.append(userIconElement)
  }
}

function replaceHiddenUserIcon(loggedIn = 'true', avatar = '') {
  if (currentCustomer && currentCustomer.email) {
    const userHideDivElement = document.querySelector('.user-drop .drop-header div.hide-dh')
    const previousUserIcon = userHideDivElement.querySelector('user-icon')
    if (previousUserIcon) {
      previousUserIcon.remove()
    }
    const userIconElement = document.createElement('user-icon')
    userIconElement.setAttribute('logged-in', loggedIn)
    userIconElement.setAttribute('avatar', avatar)


    userHideDivElement.append(userIconElement)
  }
}
// console.log("Loaded header!");
});